import { Col, Form, Select } from "antd";
import K from "../../../../utilities/constants";

export const AmountTypeField = ({ disabled, formItemName }) => (
  <Col xs={24} md={12} xl={6}>
    <Form.Item name={formItemName} initialValue={K.Format.Dollar}>
      <Select
        showSearch={false}
        disabled={disabled}
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
        options={[
          { value: K.Format.Dollar, label: "$" },
          { value: K.Format.Percentage, label: "%" },
        ]}
      />
    </Form.Item>
  </Col>
);
